
/**
 * @import internal modules
 */

import Login from "@apps-pages/login/container";
import AnalyseTempReel from "@apps-pages/real-time/container";
import AnalyseTempDifferer from "@apps-pages/delayed/container";
import E404 from "@apps-pages/e404/component";
import Demo from "@apps-pages/demo/component";
import * as URL from "@apps-enums/index";


/**
 * @import external modules
 */
import * as React from "react";
import { Redirect , Route , Switch } from "react-router-dom";
import * as Utils from '@root-utils/index';

/**
 * @param props
 */
const Component: React.FunctionComponent<JSX.Element> = (props: any): JSX.Element =>{
    // react use Hook
   // const [ isAuthenticated ] = React.useState<boolean>();
 
   // react protected route
   const PrivateRoute = ({component : Compt,  ...rest}: any): JSX.Element => {

        const routeComponent = (state: any) => (

            Utils.localStorageIsKeyExist()
                ? React.createElement(Compt,state)
                : <Redirect to={{pathname: URL.EnumUrl.HOME}}/>
                
        );
        
    return <Route {...rest} render={routeComponent}/>;

    };
    // react redirected route
    const RedirectTo = ({component : Compt,  ...rest}: any): any =>{
        const routeComponent = (state: any) => (
            Utils.localStorageIsKeyExist()
                ?  <Redirect to={{pathname: URL.EnumUrl.DEMO}}/> 
                : React.createElement(Compt,state)
        );

    return <Route {...rest} render={routeComponent}/>;

    }
   
    return(
        <Switch>
            
            <RedirectTo exact={true}  path={URL.EnumUrl.HOME} component={Login} />
            <PrivateRoute exact={true} path={URL.EnumUrl.REALTIME} component={AnalyseTempReel} />
            <PrivateRoute exact={true} path={URL.EnumUrl.DELAYED} component={AnalyseTempDifferer} />
            <PrivateRoute exact={true} path={URL.EnumUrl.DEMO} component={ Demo} />
            <PrivateRoute exact={true} path="*" component={E404} />
            
           
        </Switch>
        
    )
}


/**
 * DefaultProps values
 */
Component.defaultProps= {

}

export default  Component;


// WEBPACK FOOTER //
// ./src/apps/routes/index.tsx